import { ProtectionDetailsUpsellModalDataWib } from '../../models/protection-details/protection-details-upsell-modal-data-wib.interface';
import { RegistrationSystemCode } from '../../models/registration/registration-system-code.enum';
import { mockRegisteredItemProductDetailsAnnual } from '../registered-item/registered-item-product-details-annual.mock';
import { mockRegisteredItem } from '../registered-item/registered-item.mock';
import { mockCmsProtectionDetailsUpsellModal } from './cms-protection-details-upsell-modal.mock';

export const mockProtectionDetailsUpsellModalDataWib: ProtectionDetailsUpsellModalDataWib =
  {
    cmsProtectionDetailsUpsellModal: mockCmsProtectionDetailsUpsellModal,
    merchandiseBrand: mockRegisteredItem.merchandiseBrand,
    annualPlansEnabled: false,
    registeredItemHasAnnualPayment: false,
    registeredItemAnnualProductDetails: mockRegisteredItemProductDetailsAnnual,
    registeredItemProducts: mockRegisteredItem.products,
    systemCode: RegistrationSystemCode.InternetProductRegistration,
    registeredItemProductPriceDetails: 2.99,
    protectionDetailsPaymentOptions: [],
    prepayPrice: 2.99,
    subscriptionPrice: 2.99,
    hasDiscountPrice: false,
  };
